import React from "react";
import MapTo from "../../utils/mapto";
import styled from "styled-components";

const StyledContainer = styled.div`
    background: ${props => props.backgroundColor || 'transparent'};
    backdrop-filter: blur(20px);
`;

const Card9 = (props) => {
    const items = props?.items || props?.content?.items;
    const backgroundColor = props.backgroundColor || (props.content && props.content.backgroundColor);
    const borderRadius = props.borderRadius || (props.content && props.content.borderRadius);
    const borderRadiusTop = props.borderRadiusTop || (props.content && props.content.borderRadiusTop);
    const borderRadiusBottom = props.borderRadiusBottom || (props.content && props.content.borderRadiusBottom);

    // Separate media and content items
    const mediaItems = items?.filter(item => item.__typename === "ContentfulMedia") || [];
    const contentItems = items?.filter(item => item.__typename !== "ContentfulMedia") || [];

    return (
        <StyledContainer
            backgroundColor={backgroundColor}
            className={`card9 flex-1 flex justify-start ${borderRadius ? ` rounded-all_48` : ''}${borderRadiusTop ? ` rounded-top_48` : ''}${borderRadiusBottom ? ` rounded-bottom_48` : ''}`}
        >
            <div className="w-full relative">
                {/* First content item with header styling */}
                {contentItems.length > 0 && (
                    <div className="bg-gradient-card-header px-[48px] py-[24px] rounded-top_48">
                        <MapTo key={contentItems[0].id} items={contentItems[0]} />
                    </div>
                )}
                
                {/* Remaining content items - flex row on desktop, stacked on mobile */}
                {contentItems.length > 1 && (
                    <div className="flex flex-col lg:flex-row items-start gap-y-6 py-[24px] px-[32px]">
                        {contentItems.slice(1).map(item => (
                            <MapTo key={item.id} items={item} />
                        ))}
                    </div>
                )}

                {/* Media items - hidden on mobile */}
                {mediaItems.length > 0 && (
                    <div className="hidden lg:block absolute top-1/2 -translate-y-1/2 -ml-[45px]">
                        {mediaItems.map(item => (
                            <MapTo key={item.id} items={item} />
                        ))}
                    </div>
                )}
            </div>
        </StyledContainer>
    );
};

export default Card9; 